// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2348) return "static/chunks/2348.2e8e480b6bb68b91.js";
	if (chunkId === 5255) return "static/chunks/5255.b390041f12cbca32.js";
	if (chunkId === 1099) return "static/chunks/1099.40a05e0f0dedbeb9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"546":"7df06c9445d7c8d4","681":"fe2362ff7c78d690","814":"cdb715e3fe0525e8","3699":"0c55c08814f0e69e","3824":"50844bde2951c888","4097":"e87d2c8745cc7388","6236":"3b6b83c81c139350","6281":"7047250ef4136a83","7283":"568dc03946c7fbc9","9606":"43cebde733f5a61f"}[chunkId] + ".js";
};